module.exports = __webpack_public_path__ + "static/media/2019.552e95df.jpg";